import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { ContinuityProofProps, ContinuityComparisonProps } from "./ContinuityProof";
const ContinuityProofPanel = lazy(() => import("./ContinuityProof").then(module => ({ default: module.ContinuityProofPanel })));
const ContinuityComparison = lazy(() => import("./ContinuityProof").then(module => ({ default: module.ContinuityComparison })));
export function mountContinuityProof(
  slot: HTMLElement,
  props: ContinuityProofProps,
) {
  setStudioView("continuity-proof", `continuity-proof:${props.projectId}`, <ContinuityProofPanel {...props} />);
}
export function mountContinuityComparison(
  slot: HTMLElement,
  props: ContinuityComparisonProps,
) {
  setStudioView("continuity-comparison", "continuity-comparison", <ContinuityComparison
      key={`${props.projectId}:${props.model.sample.scene_id}`}
      {...props}
    />);
}
